<template>
  <div
    :class="[
      'box-viewmore',
      {
        open,
      },
    ]"
  >
    <div v-if="title" class="title-box v-line"> 
      <h2>{{title}}</h2>
    </div>
    <div class="" ref="box" :class="!isHidden ? 'box-content-hidden' : 'box-content'" >
      <slot id="content"/>
    </div>
    <div class="flex justify-center">
      <button class="btn-viewmore mr-0 sm:mr-auto" @click="openView()" v-if="isHidden">
		<i  class="icon icon-bor-arrow-down text-gray-800 hidden sm:block" :class="{rotate: this.open}" />
        <span>{{getExpandLabel}}</span>
        <i  class="icon icon-bor-triangle-down text-primary sm:hidden" :class="{rotate: this.open}" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['title'],
  data() {
    return {
      open: false,
      isHidden: true 
    }
  },
  mounted() {
    this.getHeight()
  },
  computed: {
    getExpandLabel() {
      return this.open ? ' 閉じる' : '詳細を見る'
    }
  },
  methods: {
    getHeight() {
      const heightOfBox = this.$refs.box.clientHeight
      if(heightOfBox < 90) {
        this.isHidden = false
      } else {
        this.isHidden = true
      }
    },
    openView() {
      this.open = !this.open
      this.$emit('open', this.open)
    }
  },
  updated() {
    this.getHeight()
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>